// extracted by mini-css-extract-plugin
export default {"table":"InfoTable_table__ZMan+"};